import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const RmaReturnsPage = loadable(() =>
  withDefaultLoaderModifiers(import("./RmaReturnsPage"))
);
